import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';
import { ROUTES } from '@/config/routes';
import { useMasterclass } from '@/contexts/MasterclassContext';
import { CaseRenderer } from '@/modules/case';

export default function Index() {
  const { caseId } = useParams<{ caseId: string }>();
  const { setSelectedCase, caseProgress, loading, instantiateCaseProgress, resetCaseProgress } =
    useMasterclass();

  const [isCheckingProgress, setIsCheckingProgress] = useState(true);

  // NOTE: progress instantiation
  useEffect(() => {
    if (!caseId || loading) return;

    const checkProgress = async () => {
      if (!caseProgress[caseId]) {
        // NOTE: we need to instantiate the caseProgress for the first time
        await instantiateCaseProgress(caseId);
      }
      setIsCheckingProgress(false);
    };

    void checkProgress();
  }, [loading, caseProgress, instantiateCaseProgress, caseId]);

  if (!caseId) {
    return <Navigate to={ROUTES.CASES} replace />;
  }

  // Synchronize context with URL
  setSelectedCase(caseId);

  // Wait for all checks to complete
  if (loading || isCheckingProgress || !caseProgress[caseId]) {
    return <Skeleton className="h-full w-full" />;
  }

  return <CaseRenderer caseId={caseId} />;
}
